export const key = "1Z1xS3vO0d";
// prettier-ignore
// export const base_url = process.env.NODE_ENV === "development" ? "http://backend.test/api/" : "https://rsuii.co.id/backend/api/";
export const base_url = "https://rsuii.co.id/backend/api/";

/** TERRA */
const TERRA_IP = "http://202.162.36.173";
const TERRA_DOMAIN = "https://antriandokter.rsuii.co.id";
// prettier-ignore
export const TERRA_APPOINTMENT = TERRA_IP + "/jadwaldokternew/appointment-new.aspx";
// prettier-ignore
export const TERRA_JADWAL = TERRA_DOMAIN + "/jadwaldokternew/jadwal-dokter.aspx";
// prettier-ignore
export const TERRA_ANTRIAN = process.env.NODE_ENV === "development" ? TERRA_IP : TERRA_DOMAIN;



// WEBPACK FOOTER //
// ./src/config/VariableComponents.js